import { Component } from 'vue-property-decorator';
import StudioModal from '@/components/modals/StudioModal.vue';
import { EModalName } from '@/helpers/modal';
import EditorBase from '@/components/editor/EditorBase';
import UserApi from '@/apis/user-api';
import { Button, Checkbox } from 'streamlabs-beaker';

const USER_CONSENT_TYPE = 'tos-2023-09-29';

@Component({
  components: {
    StudioModal,
    SButton: Button,
    SCheckbox: Checkbox,
  },
})
export default class ChangeOfTermsModal extends EditorBase {
  hasReviewed: boolean = false;
  marketingEmailSubscribed: boolean = false;

  get modalName(): string {
    return EModalName.changeOfTerms;
  }

  get showGDPRCompliance(): boolean {
    return this.currentUser?.showGDPRCompliance;
  }

  toggleHasReviewed() {
    this.hasReviewed = !this.hasReviewed;
  }

  async sendUserConsent() {
    await UserApi.updateUserConsents(USER_CONSENT_TYPE);
    await this.userModule.setUser({
      ...this.currentUser,
      ...{ hasConsentedTerms: true },
    });

    this.$modal.hide(this.modalName);

    if (this.marketingEmailSubscribed) {
      this.userModule.updateUserSettings({ marketingEmailsSubscribed: this.marketingEmailSubscribed });
      await UserApi.saveUserSettings(this.userModule.user.settings);
    }
  }
}
